import { render, staticRenderFns } from "./GroupsSelection.vue?vue&type=template&id=f7901e5a&scoped=true"
import script from "./GroupsSelection.vue?vue&type=script&lang=ts"
export * from "./GroupsSelection.vue?vue&type=script&lang=ts"
import style0 from "./GroupsSelection.vue?vue&type=style&index=0&id=f7901e5a&prod&scoped=true&lang=css"
import style1 from "./GroupsSelection.vue?vue&type=style&index=1&id=f7901e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7901e5a",
  null
  
)

export default component.exports